<template>
  <div class="privacy-wrapper">
    <div class="privacy-container">
      <h1>隐私政策（Privacy Policy）</h1>

      <p>本网站（vue3.tech）尊重并保护所有用户的隐私。本政策说明我们如何收集、使用和保护您的信息。</p>

      <h2>1. 广告服务（Google AdSense）</h2>
      <p>
        本网站使用 Google AdSense。Google 可能使用 Cookie 展示个性化广告、统计广告效果并改善体验。
        更多信息请查看：
        <a href="https://policies.google.com/technologies/ads" target="_blank">Google 广告政策</a>
      </p>

      <h2>2. Cookie 使用</h2>
      <p>
        本网站可能使用 Cookie 记录偏好、分析访问情况及展示广告。
        您可在浏览器中禁用 Cookie，但可能影响部分功能。
      </p>

      <h2>3. 第三方服务</h2>
      <p>
        本网站可能包含指向第三方网站的链接（如 GitHub、Vue 文档）。这些网站有各自的隐私政策，本网站不对其内容负责。
      </p>

      <h2>4. 信息收集</h2>
      <p>
        本网站不会主动收集用户的个人信息（如姓名、身份证、电话、邮箱）。
        第三方服务（如 Google）可能收集匿名统计数据。
      </p>

      <h2>5. 用户选择权</h2>
      <p>
        您可通过以下链接关闭个性化广告：
        <a href="https://www.google.com/settings/ads" target="_blank">关闭个性化广告</a>
      </p>

      <h2>6. 隐私政策更新</h2>
      <p>我们可能会根据需要更新本政策，更新内容将发布在本页面。</p>

      <h2>7. 联系方式</h2>
      <p>如有问题，请联系：<strong>jacklion199112@gmail.com</strong></p>
    </div>
  </div>
</template>

<script setup>
// 无需脚本逻辑
</script>

<style scoped>
/* 外层容器：可滚动但不显示滚动条 */
.privacy-wrapper {
  height: calc(100vh - 50px); /* 根据你的布局调整 */
  overflow-y: auto;
  padding: 20px;
  box-sizing: border-box;

  /* 隐藏滚动条（Firefox / Edge / Chrome / Safari） */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE/Edge */
}
.privacy-wrapper::-webkit-scrollbar {
  display: none; /* Chrome / Safari */
}

/* 内容区域 */
.privacy-container {
  max-width: 760px;
  margin: 0 auto;
  padding: 10px 16px;
  line-height: 1.55;
  font-size: 15px;
  color: #333;
}

h1 {
  margin-bottom: 14px;
  font-size: 22px;
}

h2 {
  margin-top: 18px;
  margin-bottom: 6px;
  font-size: 18px;
}

a {
  color: #42b983;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}
</style>
